import { reduce, isEqual } from 'lodash';

export function getDifferentFieldsFromObjects(obj1, obj2) {
    return reduce(obj1, (result, value, key) => (isEqual(value, obj2[key]) ? result : result.concat(key)), []);
}

export function getActionTypesResult(actionTypes, postfix) {
    return Object.keys(actionTypes).reduce((acc, cur) => {
        acc[cur] = actionTypes[cur] + postfix;
        return acc;
    }, {});
}

export const updateColumnsHeaderTable = (headerRows, column) => {
    const updatedHeaderRows = headerRows.reduce((acc, curr) => {
        if (column && curr.id === column.id) {
            curr.showColumn = !curr.showColumn;
        }
        const storageColumn = { id: curr.id, showColumn: curr.showColumn };
        return {
            ...acc,
            storageColumns: acc.storageColumns ? [...acc.storageColumns, storageColumn] : [storageColumn],
            stateColumns: acc.stateColumns ? [...acc.stateColumns, curr] : [curr]
        };
    }, {});

    return updatedHeaderRows;
};
